import { mdlStatus } from "./CompAttachmentsMdl";

export class mdlGetChangeInGeneralInfoRes {
    st: mdlStatus = new mdlStatus();
    GeneralInfo: mdlChangeInGeneralInfo = new mdlChangeInGeneralInfo();
}

export class mdlChangeInGeneralInfo {
    public PolicyNo: string = "";
    public PolicyFromDate: string = "";
    public PolicyToDate: string = "";
    public Insured_Name: string = "";
    public Insured_IDNo: string = "";
    // public Insured_DOB: string = "";
    public Insured_MobileNo: string = "";
    public Insured_EmailId: string = "";
    public Insured_Gender: string = "";
    public Insured_Nationality: number | null = null;
    public IBANNumber: string = "";
    public Insured_BuildingNo: number | null = null;
    public Insured_City: number | null = null;
    public Insured_PostalCode: number | null = null;
    public Insured_AdditionalCode: number | null = null;
    public Insured_AreaName: string = "";
    public Insured_UnitNo: number | null = null;
    public Insured_DistName: string = "";
    public Insured_StreetName: string = "";
    public Insured_WorkPlace: string = "";
    public Insured_WBuildingNo: number | null = null;
    public Insured_WCity: number | null = null;
    public Insured_WPostalCode: number | null = null;
    public Insured_WAdditionalCode: number | null = null;
    public Insured_WAreaName: string = "";
    public Insured_POBoxNo: number | null = null;
    public Insured_POCity: number | null = null;
    public Insured_POPostalCode: number | null = null;
    public IsWaseelAdd: string = "";
    public IsPostalAdd: string = "";
    public IsPOBoxAdd: string = "";
    public IBAN1: string = "";
    public IBAN2: string = "";
    public IBAN3: string = "";
    public IBAN4: string = "";
    public IBAN5: string = "";
    public IBAN6: string = "";
    public Bankname: string = "";
    public BankCode: string = "";
    public Insured_PhoneNo: string = "";
    public IBANNo: string = "";
    public RequestNotes: string = "";
    public UserId: string = "";
    public NoOfDays: string = "";
    public PresentPremium: number = 0;
    public EndorsementDesc: string = "";
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetChangeInGeneralInfoRes.ts